import { createBrandTheme } from '../../createBrandTheme';
import sandfieldLogo from './sandfield_logo.png';
import { BrandConfig } from '../../brandConfig';

const sandfieldTheme = createBrandTheme({
	palette: {
		primary: { main: '#FF8600' },
		secondary: { main: '#FFB665' },
		background: {
			default: '#F6F0EC', //sandfield light grey for background
			paper: '#FFFFFF', //white for cards and paper elements
		},
		text: {
			primary: '#1C3D49', //sandfield dark blue for text and icons
		},
	},
	app: {
		navigation: {
			selectedBackground: '#F7E0C9',
			selectedText: '#7A4000',
		},
	},
	// Headings inherit fontFamily from `typography.fontFamily` and their colour
	// from palette.text.primary, so only the values that genuinely differ from
	// the shared default are listed here.
	typography: {
		fontFamily: 'Blinker, sans-serif',
		h3: {
			fontFamily: 'DM Sans, sans-serif', //secondary brand font
		},
		h5: {
			color: '#1a1a1a', //near-black, deliberately darker than text.primary
			fontSize: '0.95rem',
			fontWeight: 700,
			lineHeight: 1.2, //tighter than MUI's 1.334 for this small heading
		},
	},
	components: {
		MuiButton: {
			styleOverrides: {
				contained: {
					backgroundColor: '#fc8f12',
					color: '#1C1C1C',
					'&:hover': {
						backgroundColor: '#cf7f23',
					},
				},
			},
		},
		MuiPickersDay: {
			styleOverrides: {
				root: {
					'&.Mui-selected': {
						backgroundColor: '#ff6b00', // Selected date circle
						'&:hover': {
							backgroundColor: '#e66000',
						},
					},
					'&:focus.Mui-selected': {
						backgroundColor: '#ff6b00',
					},
				},
			},
		},
	},
});

export const sandfieldBrandConfig: BrandConfig = {
	theme: sandfieldTheme,
	logo: sandfieldLogo,
};
